import { useState } from 'react';
import css from './RollbackButton.module.css';
import ConfirmDialog from './ConfirmDialog';

function RollbackButton({ enrollId, onConfirm }) {
    const [confirmDialog, setConfirmDialog] = useState(false);

    const handleNo = () => {
        setConfirmDialog(st => false)
    }

    const handleYes = () => {
        onConfirm(enrollId);
        setConfirmDialog(st => false)

    }

    const confirmDialogMessage = 
        {
            title: 'Rollback',
            question: 'Are you sure you want to rollback this student from the course?'
        }

    const rollbackHandle = () => {
        setConfirmDialog((st) => true);
        // console.log(enrollId);
    };

    return (
        <>
            <button className={css.rollbackButton} onClick={() => rollbackHandle()}>
                Rollback
            </button>
            {confirmDialog &&
                <ConfirmDialog handleYes={handleYes} handleNo={handleNo} content={confirmDialogMessage}/>
                }
        </>
    );
}

export default RollbackButton;
